export default __webpack_public_path__ + "static/media/gallery_01.760b5ea8.jpg";